import axiosInstance from "./axiosInstance";

export async function changePassword() {
  return await axiosInstance.get("/cash");
}

export async function updateProfile() {
  return await axiosInstance.get("/cash");
}
